import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class SelectionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false
    };
  }

  componentDidMount() {
    const { checkBoxCard, checkBoxChecked } = this.props;

    if (checkBoxCard) {
      this.setState({checked: checkBoxChecked});
    }
  }

  handleClick = () => {
    const { onClick, checkBoxCard } = this.props;
    if (checkBoxCard) {
      this.setState({checked: !this.state.checked});
    }
    if (onClick) {
      onClick();
    }
  }
  
  render() {
    const { extraClass, label, imgSrc, checkBoxCard } = this.props;
    let checkbox;

    if (checkBoxCard) {
      let checkboxId = label.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
      checkbox = <div className="c-selection-card__checkbox custom-checkbox"><input id={checkboxId} type="checkbox" value={label} checked={this.state.checked} readOnly/><label><span className="sr-only">{label}</span></label></div>;
    }

    return (
      <article className={"c-selection-card " + extraClass} onClick={() => {this.handleClick()}}>
        <header className="c-selection-card__header">
          <span className="c-selection-card__label t-option">{label}</span>
          { checkbox }
        </header>
        <div className="c-selection-card__image-wrapper">
          <img src={imgSrc} className="c-selection-card__image" alt=""/>
        </div>
      </article>
    );
  }
}

export default withTranslation('translations')(SelectionCard);
